import { useEffect, useState } from "react";
import { initVersionCheck } from "../utils/versionCheck";
import { Alert } from "flowbite-react";

/**
 * VersionChecker Component
 * Silently checks for new app versions and auto-reloads when detected
 */
const VersionChecker = () => {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);

  useEffect(() => {
    // Initialize version checking
    const cleanup = initVersionCheck();

    // Listen for new version detection
    const checkInterval = setInterval(async () => {
      const { checkForNewVersion } = await import("../utils/versionCheck");
      const hasNewVersion = await checkForNewVersion();

      if (hasNewVersion) {
        setShowUpdateNotification(true);
      }
    }, 30 * 60 * 1000); // Check every 30 minutes

    // Cleanup on unmount
    return () => {
      cleanup();
      clearInterval(checkInterval);
    };
  }, []);

  if (!showUpdateNotification) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-fade-in">
      <Alert color="info" className="shadow-lg">
        <span className="font-medium">Neue Version wird geladen...</span>
      </Alert>
    </div>
  );
};

export default VersionChecker;
